import { createAction, props } from '@ngrx/store';
import { NotificationContentError } from './notification-content.errors';
import { LoadResult } from '../types';
import { NotificationContentFilter } from './types';
import { DataTableSort, DataTablePagination, ViewNotificationContent } from 'studio-components';

const Type = '[Notification Content]';

export const NotificationContentLoadAction = createAction(`${Type} Load`);
export const NotificationContentLoadSucceededAction = createAction(
  `${Type} Load Succeeded`,
  props<LoadResult<ViewNotificationContent>>(),
);
export const NotificationContentLoadErroredAction = createAction(
  `${Type} Load Errored`,
  props<{ apiError: NotificationContentError }>(),
);

export const NotificationContentSortChangedAction = createAction(
  `${Type} Sort Changed`,
  props<{ sort: DataTableSort<'datetimeAdded' | 'datetimeModified'> }>(),
);

export const NotificationContentPaginationChangedAction = createAction(
  `${Type} Pagination Changed`,
  props<{ pagination: DataTablePagination }>(),
);

export const NotificationContentFilterChangedAction = createAction(
  `${Type} Filter Changed`,
  props<{ filter: NotificationContentFilter }>(),
);

export const DeleteNotificationContentClickedAction = createAction(
  `${Type} Delete Clicked`,
  props<{ notificationContentId: number }>(),
);

export const DeleteNotificationContentCancelledAction = createAction(`${Type} Delete Cancelled`);

export const DeleteNotificationContentAction = createAction(
  `${Type} Delete`,
  props<{ notificationContentId: number }>(),
);

export const DeleteNotificationContentSucceededAction = createAction(`${Type} Delete Succeeded`);

export const DeleteNotificationContentErroredAction = createAction(
  `${Type} Delete Errored`,
  props<{ apiError: NotificationContentError }>(),
);

export const PublishNotificationContentClickedAction = createAction(
  `${Type} Publish Clicked`,
  props<{ notificationContentId: number }>(),
);

export const PublishNotificationContentCancelledAction = createAction(`${Type} Publish Cancelled`);

export const PublishNotificationContentAction = createAction(
  `${Type} Publish`,
  props<{ notificationContentId: number }>(),
);

export const PublishNotificationContentSucceededAction = createAction(
  `${Type} Published Succeeded`,
);
export const PublishNotificationContentErroredAction = createAction(
  `${Type} Publish Errored`,
  props<{ apiError: NotificationContentError }>(),
);

export const NotificationContentErrorTimedOutAction = createAction(
  '[Nav Bar] Notification Content Error Timed Out',
);
